import React, { useState, useEffect } from 'react';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import {
  LoginTitle,
  LoginSubTitle,
  SignInButton,
  FirstAccessContainer,
  LoadingIcon,
  CustomLinkSpan,
} from './styles';
import { TimeExceeded } from '../../../../pages/Auth/TimeExceeded';
import { useDispatch, useSelector } from 'react-redux';
import api from '~/services/api';

export function CodeSentScreenForgotPassword() {
  const [seconds, setSeconds] = useState(180);
  const [code, setCode] = useState(new Array(6).fill(''));
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const isInvalidCode = useSelector((state) => state.invalidCodeReducer.invalidCode);
  const reducerUserId = useSelector((state) => state.stepsReducer.reducerUserId);

  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      return () => clearTimeout(timer);
    }
    if (seconds <= 0) {
        dispatch({ type: "TIME_EXCEEDED" });
    }
  }, [seconds]);

  const handleChange = (value, index) => {
    if (/^\d?$/.test(value)) { 
      const newCode = [...code];
      newCode[index] = value; 
      setCode(newCode);
  
      if (value.length === 1 && index < 5) {
        document.getElementById(`code-input-${index + 1}`).focus(); 
      }
      if (value === '' && index > 0) {
        document.getElementById(`code-input-${index - 1}`).focus(); 
      }
    }
  };

  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData('text').slice(0, 6); 
    const newCode = pastedData.split('');
    setCode(newCode);

    const lastIndex = newCode.length - 1;
    if (lastIndex >= 0 && lastIndex <= 5) {
      document.getElementById(`code-input-${lastIndex}`).focus();
    }

    e.preventDefault();
  };

  const isCodeComplete = code.every(num => num !== '');

  const postValidationToken = async () => {
    setLoading(true);
    const token = code.join('');

    const access_token = localStorage.getItem('access_token');
    let userId;
     
    if (localStorage.getItem('userId') === 'null' || localStorage.getItem('userId') === 'undefined') {
      userId = reducerUserId;
    } else {
      userId = localStorage.getItem('userId');
    }

    const email = localStorage.getItem('email');

    const headers = {
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
      client_id: process.env.REACT_APP_CLIENT_ID,
    };

    const body = {
      email: email,
      token: token
    };

    try {
      const response = await api.post(`residential/store/v1/users/reset-password-validate-token`, body, { headers });
      const sessionToken = response.headers['x-reset-password-session-token'];
      localStorage.setItem('reset_password_session_token', sessionToken);
      dispatch({ type: "SET_CODE_TOKEN", codeToken: token });
      dispatch({ type: "SET_STEP", step: 40 });
    } catch (error) {
      setLoading(false);
      setCode(new Array(6).fill(''));
      dispatch({ type: "SET_INVALID_CODE", invalidCode: true });
    }
  };

  useEffect(() => {
    if (isInvalidCode) {
      setCode(new Array(6).fill(''));
      setLoading(false);
    }
  }, [isInvalidCode]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      dispatch({ type: 'SET_STEP', step: 0 });
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  return (
    <>
      {seconds <= 0 ? (
        <TimeExceeded isMFA={false} />
      ) : (
        <>
          <LoginTitle className="mb-3">
            {isInvalidCode ? (
              <>
                Código inválido <ClearIcon style={{ color: '#E8454F', fontSize: '30px' }} />
              </>
            ) : (
              <>
                Código enviado <CheckIcon style={{ color: '#47A150', fontSize: '30px' }} />
              </>
            )}
          </LoginTitle>
          
          <LoginSubTitle>
            {isInvalidCode ? 'Digite o código novamente' : 'Digite abaixo o código que você recebeu'}
          </LoginSubTitle>
          
          <div
            style={{
              display: 'flex',
              gap: '10px',
              justifyContent: 'center',
              paddingBottom: '30px',
            }}
            onPaste={handlePaste}
          >
            {code.map((num, index) => (
                <input
                  key={index}
                  id={`code-input-${index}`}
                  value={num}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength="1"
                  onPaste={handlePaste}
                  {...(isMobile && { inputMode: "numeric", type: "tel" })} 
                  style={{
                    width: '40px',
                    height: '50px',
                    fontSize: '24px',
                    textAlign: 'center',
                    border: 'none',
                    borderBottom: '2px solid black',
                    outline: 'none',
                    color: '#000FFF',
                    borderBottomColor: '#000FFF',
                  }}
                />
            ))}
          </div>
          <LoginSubTitle style={{ color: '#000FFF' }} className="mb-3">
            {seconds} segundos restantes
          </LoginSubTitle>
          <SignInButton
            type="submit"
            className="mt-4"
            disabled={loading || !isCodeComplete} 
            style={{
              backgroundColor: loading || !isCodeComplete ? 'gray' : '#000FFF',
              cursor: loading || !isCodeComplete ? 'not-allowed' : 'pointer',
            }}
            onClick={postValidationToken}
          >
            {loading ? (
              <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
            ) : (
              <span>Confirmar e criar nova conta</span>
            )}
          </SignInButton>

          <FirstAccessContainer className="mt-3 w-100" onClick={() => dispatch({ type: "SET_STEP", step: 10 })}>
            <SignInButton outline disabled={loading}>
              <span>Voltar</span>
            </SignInButton>
          </FirstAccessContainer>
          
          {isInvalidCode && (
            <FirstAccessContainer className="mt-3 w-100" onClick={() => dispatch({ type: "SET_STEP", step: 20 })}>
              <CustomLinkSpan>
                Obter código de outra maneira
              </CustomLinkSpan>
            </FirstAccessContainer>
          )}
        </>
      )}
    </>
  );
}
